import React from "react";
import { useTranslation } from "react-i18next";
import { translationConstants } from "../../../constants";

const VerifiedHeading = () => {
  const { t } = useTranslation();
  return (
    <span className="becomeverifiedPara">
      {t(translationConstants.becomeverifieduser)}
      <hr />
    </span>
  );
};

export default VerifiedHeading;
